// extracted by mini-css-extract-plugin
module.exports = {"headerSearch":"SearchBarHeader_headerSearch__ZqT9j","hideDesktop":"SearchBarHeader_hideDesktop__9A4hN","hideMobile":"SearchBarHeader_hideMobile__gYk9n"};